export default __webpack_public_path__ + "static/media/sdt_beginners_icon_optm.7bc3bf38.svg";